import React from 'react'
import './addBank.css'
import Layout from '../Layout'
import SellerOnboardFlutterwave from '../../../utils/CommonFunctionality/SellerOnboard/Flutterwave'

const AddBankFlutter = () => {
    return (
        <Layout>
            <div className="postProductContainer">
                <h2 className="ppTitle">OnBoarding</h2>
                <SellerOnboardFlutterwave />
            </div>
        </Layout>
    )
}

export default AddBankFlutter
